import { Component, ErrorInfo, FC, lazy } from "react";
import { useLocation } from "react-router-dom";

import styles from "./dummy-ui.module.scss";

const ErrorView = lazy(() => import("../partials/error-view/error-view"));

export interface SuspenseErrorBoundaryProps {
  hideError?: boolean;
  children: React.ReactNode;
  className?: string;
  hasDummyUI?: boolean;
}

export class SuspenseErrorBoundary extends Component<
  SuspenseErrorBoundaryProps,
  {
    error?: Error;
  }
> {
  public state = {
    error: undefined,
  };

  constructor(props: SuspenseErrorBoundaryProps) {
    super(props);
  }

  public componentDidCatch(error: Error, { componentStack }: ErrorInfo) {
    // Capture error to sentry whenever sentry is ready
    import("@sentry/react").then((Sentry) => {
      if ((error as any)?.doNotCapture) return;
      Sentry.captureException(error, {
        contexts: { react: { componentStack } },
      });
    });

    this.setState({ error });
  }

  public render() {
    if (this.state.error) {
      if (this.props.hideError) return null;
      // You can render any custom fallback UI

      const error = (
        <ErrorView
          className={this.props.className}
          error={this.state.error}
          onRetry={() => this.setState({ error: undefined })}
        />
      );

      return <ErrorUI>{error}</ErrorUI>;
    }

    return this.props.children;
  }
}

export const ErrorUI: FC = ({ children }) => {
  const location = useLocation();

  const isGame =
    /\/gm_/i.test(location.pathname) || /_hotlink/i.test(location.pathname);

  if (isGame)
    return (
      <div className={`${styles.gameLoader} ${styles.darkUI}`}>{children}</div>
    );
  return <>{children}</>;
};
